// OWNER: attorney module. Route objects relative to /w/:wsId, spread into the router by src/app/router.tsx.
// Pages are lazy-loaded so each feature is its own chunk. Add routes here; don't edit the router.
import type { RouteObject } from 'react-router';

const pages = () => import('./pages');

export const routes: RouteObject[] = [
  /** FR-8.2, FR-8.5 */
  { path: 'records/decisions', lazy: async () => ({ Component: (await pages()).DecisionsPage }) },
  { path: 'records/decisions/new', lazy: async () => ({ Component: (await pages()).DecisionFormPage }) },
  { path: 'records/decisions/:decisionId', lazy: async () => ({ Component: (await pages()).DecisionDetailPage }) },
  { path: 'records/decisions/:decisionId/edit', lazy: async () => ({ Component: (await pages()).DecisionFormPage }) },
  /** FR-8.1, FR-8.3, FR-8.4 (?tab=report|transactions|expenses&from=&to=) */
  { path: 'records/attorney-report', lazy: async () => ({ Component: (await pages()).AttorneyReportPage }) },
];
